import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import HelpOutline from '@material-ui/icons/HelpOutline';
import IconButton from '@material-ui/core/IconButton';
import logo from '../../../img/logo/logo_light.svg';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    position: 'relative'
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 0,
  },
  appBar: {
    background: '#fff',
    color: '#222',
    zIndex: theme.zIndex.drawer + 1,
    borderBottom: '1px solid #F2F3F4',
  },
  iconButton: {
    color: '#dddddd'
  },
  flexMenuWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  textNormal: {
    textTransform: 'none'
  },
  buttonBlue: theme.custom.button.blue
});


class AppBarDesktop extends React.PureComponent {

  state = {
    anchorEl: null,
  };

  render() {
    const { classes, auth } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div className={classes.root}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            {/* <Typography color="inherit" className={classes.grow} component={Link} to='/'> */}
            <Link to='/account/home'>
              <img src={logo} style={{ maxHeight: 28, width: 180 }} />
            </Link>

            {/* </Typography> */}

            <div>
              {!auth.is_authenticated && (
                <React.Fragment>
                  <Button component={Link} to="/how-it-works" className={classes.textNormal}>¿Cómo participar?</Button>
                  <Button component={'a'} href="https://cosmocare.eu/contact" target="_blank" className={classes.textNormal}>Contacto</Button>
                  <Button
                    component={Link}
                    variant="outlined"
                    to="/auth/login"
                    className={classNames(classes.textNormal, classes.buttonBlue)}
                    style={{ marginLeft: 15 }}
                  >
                    Iniciar sesión
                  </Button>
                </React.Fragment>
              )}
              {auth.is_authenticated &&
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  className={classes.iconButton}
                >
                  <HelpOutline />
                </IconButton>
              }
            </div>

          </Toolbar>
        </AppBar>
      </div>
    )
  }
}

export default connect(state => ({
  auth: state.auth
}))(withStyles(styles)(AppBarDesktop));


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppBarDesktop.js